// create audience api
import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  getReportParticipantInfo: {
    method: 'GET',
    url: `${configs.baseUrl}/api/audiences/{participantId}/audience-info`,
  },
  getParticipantReport: {
    method: 'GET',
    url: `${configs.baseUrl}/api/audiences/{participantId}/audience-info-report`,
  },

  // For shared report only
  //-----------------------
  getSharedParticipantReport: {
    method: 'GET',
    url: `${configs.baseUrl}/api/audiences/{participantId}/shared-audience-info-report`,
  },
  getSharedParticipantReportV2: {
    method: 'GET',
    url: `${configs.baseUrl}/api/audiences/{participantId}/shared-audience-info-report-v2`,
  },
  // ------------------------
  getParticipantReportV2: {
    method: 'GET',
    url: `${configs.baseUrl}/api/audiences/{participantId}/audience-info-report-v2`,
  },

  getParticipantReportMultiSessionV2: {
    method: 'GET',
    url: `${configs.baseUrl}/api/presenting-sessions/export/{participantId}/audience-info-report-v2`,
  },
  getParticipantReportMultiSessionV5: {
    method: 'GET',
    url: `${configs.baseUrl}/api/presenting-sessions/export/{participantId}/audience-info-report-v5`,
  },
  getParticipantReportV5: {
    method: 'GET',
    url: `${configs.baseUrl}/api/audiences/{participantId}/audience-info-report-v5`,
  },
  getParticipantReportForMultiSessions: {
    method: 'GET',
    url: `${configs.baseUrl}/api/presenting-sessions/export/{participantId}/audience-info-report`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const getReportParticipantInfo = async (presentationId, participantId) => {
  const res = await resource.getReportParticipantInfo({ participantId, presentationId })
  return res.body
}
// For Share report only
//-----------------------
const getSharedParticipantReport = async (payload) => {
  const res = await resource.getSharedParticipantReport(payload)
  return res.body?.participantAnswers
}

const getSharedParticipantReportV2 = async (payload) => {
  const res = await resource.getSharedParticipantReportV2(payload)
  return res.body?.participantAnswers
}
// ------------------------

// payload: { presentationId, participantId, audienceIdTemp, presentationIdTemp, switchPresentationAudience }
const getParticipantReport = async (payload) => {
  const res = await resource.getParticipantReport(payload)
  return res.body?.participantAnswers
}

const getParticipantReportV2 = async (payload) => {
  const res = await resource.getParticipantReportV2(payload)
  return res.body?.participantAnswers
}

const getParticipantReportMultiSessionV2 = async (payload) => {
  const res = await resource.getParticipantReportMultiSessionV2(payload)
  return res.body?.participantAnswers
}

const getParticipantReportMultiSessionV5 = async (payload) => {
  const res = await resource.getParticipantReportMultiSessionV5(payload)
  return res.body?.participantAnswers
}

const getParticipantReportV5 = async (payload) => {
  const res = await resource.getParticipantReportV5(payload)
  return res.body?.participantAnswers
}

const getParticipantReportForMultiSessions = async (payload) => {
  const res = await resource.getParticipantReportForMultiSessions(payload)
  return res.body?.participantAnswers
}

export default {
  initResource,
  getReportParticipantInfo,
  getParticipantReport,
  getParticipantReportV2,
  getParticipantReportMultiSessionV2,
  getParticipantReportMultiSessionV5,
  getParticipantReportV5,
  getSharedParticipantReport,
  getSharedParticipantReportV2,
  getParticipantReportForMultiSessions,
}
